import React, { Component } from "react";
// styles for page
import "./reg_step2.css";
// icon for page
import Ionicon from "react-ionicons";
// request module
import axios from "axios";
// navigation arrows
import { NavigationArrow, edit } from "../other components/navigation_arrow";
import { Saved } from "../other components/savedAlert";
// cropper module
import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";

export default class RegStep2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productPhoto3: null,
      product3Heading: null,
      product3HeadingInitial: "GET THIS PRODUCT",
      product3Desc: null,
      product3DescInitial: `Put the full description of your prodcut here\n\nLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's `,
      button1Value: null,
      button1ValueInitial: "BUY 10$",
      product3ShortDesc: null,
      product3ShortDescInitial: "Type here some short description",
      editorOpen: false,
      activeImg: null,
      saved: false,
      history: {
        // field history and current index
        productPhoto3: [null],
        productPhoto3Index: 0,
        //
        product3Heading: [null],
        product3HeadingIndex: 0,
        //
        product3Desc: [null],
        product3DescIndex: 0,
        //
        button1Value: [null],
        button1ValueIndex: 0,
        //
        product3ShortDesc: [null],
        product3ShortDescIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      }
    };
    this.actionStep = 1;
  }

  // add drag event
  componentDidUpdate=()=>{
    if (this.state.productPhoto3) {
      document.getElementsByClassName(
        "labelUploadproductPhoto3"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "labelUploadproductPhoto3"
      )[0].style.backgroundColor = "transparent";
    } else {
      document.getElementsByClassName(
        "labelUploadproductPhoto3"
      )[0].style.display = "flex";
      document.getElementsByClassName(
        "labelUploadproductPhoto3"
      )[0].style.backgroundColor = "#f2f2f2";

      this.removeImageCache("productPhoto3_upload");
    }
  }
  componentDidMount = () => {
    let dragArea = [
      document.getElementsByClassName("labelUploadproductPhoto3")[0]
    ];
    dragArea.map((item, index) => {
      // get the last class name
      let list = item.classList;
      let dragAreaClass = list[list.length - 1];
      dragArea[index].addEventListener("dragenter", this.dragenter, false);
      dragArea[index].addEventListener("dragleave", this.dragleave, false);
      dragArea[index].addEventListener("dragover", this.dragover, false);
      dragArea[index].addEventListener("drop", this.handleOnchange, false);
    });
    // this.checkLogoUploaded();
  };

  // drag and drop
  dragenter = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragleave = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragover = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  //
  // remove cache
  removeImageCache = img => {
    document.getElementById(img).value = "";
  };
  // get bloob url from file
  getUrlFromObj = e => {
    let imagePreview;
    let binaryData = [];
    if (e) {
      binaryData.push(e);
      imagePreview = window.URL.createObjectURL(new Blob(binaryData));
      return imagePreview;
    }
    return;
  };
  // get image preview from input files
  handleOnchange = event => {
    event.stopPropagation();
    event.preventDefault();
    let file = event.target.files || event.dataTransfer.files;
    let fileSize = file[0].size / 1024;
    if (
      ((event.target && file.length != 0) ||
        (event.dataTransfer && file.length != 0)) &&
      fileSize < 500
    ) {
      let labelClass = event.target.closest("label");
      let str = labelClass.className;
      let stateName = str.substr(
        str.search("labelUpload") + "labelUpload".length,
        str.length
      );
      labelClass.style.display = "none";
      labelClass.parentElement.style.backgroundColor = "transparent";
      this.setState(
        { [stateName]: this.getUrlFromObj(file[0]) },
        this.handleEditor(this.getUrlFromObj(file[0]), stateName)
      );
      this.handleHistory(stateName, this.getUrlFromObj(file[0]));
    } else if (fileSize > 500) {
      alert("invalid file size,recommended size 500kb  ");
    } else {
      return false;
    }
  };
  // set  field value on change
  handleChange = event => {
    this.setState(
      {
        [event.target.name]: event.target.value
      },
      this.handleHistory(event.target.name, event.target.value)
    );
  };
  // modify history object
  handleHistory = (name, value) => {
    // create copy of history obbject for manipulation
    let history = this.state.history;
    if (history.lastModifiedElement.length > 15) {
      history = {
        // field history and current index
        productPhoto3: [null],
        productPhoto3Index: 0,
        //
        product3Heading: [null],
        product3HeadingIndex: 0,
        //
        product3Desc: [null],
        product3DescIndex: 0,
        //
        button1Value: [null],
        button1ValueIndex: 0,
        //
        product3ShortDesc: [null],
        product3ShortDescIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      };
    }
    // add value  to history array
    history[name].push(value);
    history[`${name}Index`] = history[`${name}Index`] + this.actionStep;
    // // reset last modified
    history.lastModifiedElement.push(name);
    history.lastModifiedElementIndex = history.lastModifiedElement.length - 1;
    this.setState({ history: history });
  };
  actionUndo = command => {
    // document.execCommand(command, false, null);
    // clone history object
    let history = this.state.history;
    let lastElementKey = history.lastModifiedElementIndex;
    let action = history.lastModifiedElement[lastElementKey];

    let key = null;
    let value = null;
    if (
      action &&
      history[`${action}Index`] <= history[action].length &&
      lastElementKey > 0
    ) {
      console.log(history[action].length);
      if (command === "undo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex - 1;
        // get action by lastmodified element  index
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] - this.actionStep;
      }
      if (command === "redo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex + 1;
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] + this.actionStep;
      } else if (history[`${action}Index`] > history[action].length) {
        return false;
      }
      // change last modified element index
      key = history[`${action}Index`];
      if (key <= 0) {
        value = "";
      } else if (key > 0 && key < 16) {
        value = history[action][key];
      }
    } else {
      return false;
    }
    console.log(action);
    // get last action field name
    let ev = {
      target: {
        name: action,
        value: value
      }
    };

    this.setState(
      {
        [action]: value,
        history: history
      },
      () => this.handleCheck(ev)
    );
  };
  // check if enter pressed on textarea
  handleKeyPress = e => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      e.target.blur();
    }
  };
  // empty textarea on focus
  handleOnFocus = event => {
    event.preventDefault();
    event.target.placeholder = "";
  };
  // check if textarea value equal to 0 return default value
  handleCheck = event => {
    let value = event.target.value;
    let name = event.target.name;
    if (value === 0 || value === "" || value === null) {
      document.getElementsByName(name)[0].placeholder = this.state[
        name + "Initial"
      ];
    }
  };
  // remove upload photo
  removeUpload = eventItem => {
    let labelClass = "labelUpload" + eventItem;
    document.getElementsByClassName(labelClass)[0].style.display = "block";
    document.getElementsByClassName(
      labelClass
    )[0].parentElement.style.backgroundColor = "#f2f2f2";
    this.setState(
      {
        [eventItem]: null
      },
      this.removeImageCache(eventItem + "_upload")
    );
  };

  // calls to open editor
  handleEditor = (img, key) => {
    this.setState({
      editorOpen: true,
      activeImg: img,
      activeImgKey: key
    });
    document.body.style.overflow = "hidden";
  };
  // editor initiallize settings
  editorInitializze = () => {
    let cropper = this.refs.cropper;
    let image = this.refs.cropper.getImageData();
    cropper.setCanvasData({
      widtht: image.width,
      height: image.height
    });
    cropper.setCropBoxData({
      widtht: image.width,
      height: image.height
    });
  };
  // cropper module actions
  editorAction = action => {
    let activeImage = this.refs.cropper;
    switch (true) {
      case action == "rotate":
        activeImage.rotate(90);
        break;
      case action == "crop":
        let canvas = activeImage.getCroppedCanvas({
          width: activeImage.getCropBoxData().width,
          heigh: activeImage.getCropBoxData().height
        });
        activeImage.replace(canvas.toDataURL(), false);
        break;
      case action == "save" || action == "close":
        let canvasFinish = null;
        let key = this.state.activeImgKey;
        if (action == "save") {
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }
        if (action == "close") {
          activeImage.setCropBoxData({
            width: 600,
            left: 100
          });
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }

        if (canvasFinish) {
          this.setState(
            { [key]: canvasFinish.toDataURL() },
            this.closeEditor()
          );
        }
        break;
      case action == "undo":
        activeImage.replace(this.state.activeImg, false);
        break;
    }
  };
  // close editor view
  closeEditor = () => {
    this.setState({
      editorOpen: false,
      activeImg: null,
      activeImgKey: null
    });
    document.body.style.overflow = "auto";
  };
  componentWillReceiveProps = nextProps => {
    if (nextProps.save && nextProps.save === 2 && nextProps.show === 1)
      this.SendData();
    let action = nextProps.action;
    if (action) {
      this.actionUndo(action);
    }
  };
  SendData = () => {
    let formData = new FormData();
    formData.append(
      "image",
      new File([this.state.productPhoto3], "productPhoto", {
        type: "image/jpg",
        lastModified: Date.now()
      })
    );
    let data = JSON.stringify({
      productHeading: this.state.product3Heading,
      productDesc: this.state.product3Desc,
      productShortDesc: this.state.product3ShortDesc,
      productButtonText: this.state.button1Value
    });
    formData.append("sub", window.localStorage.getItem("subdomain"));
    formData.append("page", "second page");
    formData.append("type", "page");
    formData.append("data", data);

    // your request here
    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
  };
  saveAlert = () => {
    setTimeout(
      () =>
        this.setState({
          saved: true
        }),
      0
    );
    setTimeout(
      () =>
        this.setState({
          saved: false
        }),
      1500
    );
  };

  render = () => {
    let showCloseButtonProduct3 = null;
    this.state.productPhoto3
      ? (showCloseButtonProduct3 = true)
      : (showCloseButtonProduct3 = false);
    let logoUploaded;
    window.localStorage.hasOwnProperty("logo")
      ? (logoUploaded = true)
      : (logoUploaded = false);

    const logoUploadedStyle = {
      height: "auto",
      background: "transparent"
    };
    let style;
    this.props.show
      ? (style = { display: "block" })
      : (style = { display: "none" });
    return (
      <div
        className="regStep step2"
        // onClick={this.handleChangeEditable}
        style={style}
      >
        <div className="row">
          <div
            className="imageUpload uploadLogo"
            style={logoUploaded ? logoUploadedStyle : null}
          >
            {logoUploaded ? (
              <img src={window.localStorage.getItem("logo")} />
            ) : (
              <div className="parentSection">
                <div className="perfectCenter">
                  <Ionicon icon="md-camera" fontSize="48px" color="#bdc3c7" />
                </div>
                <div className="perfectCenter">
                  <p className="logoBigText">YOUR LOGO</p>
                  <p className="logoSmallText">
                    Drag {"&"} Drop or click to upload{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="sectionUpload">
          <div className="rowL reverse">
            <div className="columnLeft perfectCenter">
              {showCloseButtonProduct3 && (
                <Ionicon
                  icon="ios-close-circle"
                  fontSize={30}
                  className="removeIcon"
                  color="#f9dd31"
                  onClick={() => this.removeUpload("productPhoto3")}
                />
              )}
              <label
                htmlFor="productPhoto3_upload"
                className="labelUploadproductPhoto3"
              >
                <div className="parentSection">
                  <div className="perfectCenter">
                    <Ionicon icon="md-camera" fontSize="74px" color="#c8c8c8" />
                  </div>
                  <div className="perfectCenter">
                    <p className="big">
                      DRAG {`&`} DROP OR CLICK HERE
                      <br />
                      TO UPLOAD
                      <br />
                      THE BEST PHOTO OF YOUR PRODUCT
                    </p>
                    <p className="small">
                      recommended size ↔ 600 x ↕ 560px
                      <br />
                      max 500 kb
                    </p>
                  </div>
                </div>
                <input
                  type="file"
                  onChange={this.handleOnchange}
                  id="productPhoto3_upload"
                  name="productPhoto3"
                  accept="image/*"
                />
              </label>
              {this.state.productPhoto3 ? (
                <img
                  src={this.state.productPhoto3}
                  onClick={() =>
                    this.handleEditor(this.state.productPhoto3, "productPhoto3")
                  }
                />
              ) : null}
            </div>
            <div className="columnRight perfectCenter">
              <label className="labelforHover">
                <textarea
                  tabIndex="1"
                  spellcheck="false"
                  className="heading"
                  value={this.state.product3Heading}
                  name="product3Heading"
                  placeholder={this.state.product3HeadingInitial}
                  onChange={this.handleChange}
                  onFocus={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  rows="2"
                  maxLength="25"
                />
                {edit(40)}
              </label>
              <label className="labelforHover">
                <textarea
                  tabIndex="2"
                  spellcheck="false"
                  className="description grayTxt"
                  value={this.state.product3Desc}
                  name="product3Desc"
                  placeholder={this.state.product3DescInitial}
                  onChange={this.handleChange}
                  onFocus={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  rows="6"
                  maxLength="60"
                />
                {edit(40)}
              </label>
              <button className="yButton">
                <label className="labelforHover">
                  <textarea
                    tabIndex="3"
                    spellcheck="false"
                    className="buttonArea"
                    value={this.state.button1Value}
                    placeholder={this.state.button1ValueInitial}
                    onChange={this.handleChange}
                    onFocus={this.handleOnFocus}
                    onBlur={this.handleCheck}
                    onKeyPress={this.handleKeyPress}
                    name="button1Value"
                    rows="1"
                    maxLength="15"
                  />
                  {edit(30)}
                </label>
              </button>
            </div>
          </div>
        </div>
        <div className="alternate">
          <div className="alertnateChild">
            <label className="labelforHover">
              <textarea
                tabIndex="4"
                spellcheck="false"
                className="description grayTxt"
                value={this.state.product3ShortDesc}
                name="product3ShortDesc"
                placeholder={this.state.product3ShortDescInitial}
                onChange={this.handleChange}
                onFocus={this.handleOnFocus}
                onBlur={this.handleCheck}
                rows="1"
                maxLength="35"
              />
              {edit(40)}
            </label>
          </div>
        </div>
        {this.state.editorOpen && (
          <div className="overlayEditor">
            <Cropper
              ref="cropper"
              src={this.state.activeImg}
              className="editorBody"
              // Cropper.js options
              autoCrop={true}
              aspectRatio={1.071}
              background={false}
              guides={false}
              ready={this.editorInitializze}
              center={true}
              zoomable={false}
            />
            <div className="editorTools perfectCenter">
              <Ionicon
                icon="ios-undo"
                className="editorButton"
                fontSize="40px"
                color="white"
                onClick={() => this.editorAction("undo")}
              />
              <Ionicon
                icon="ios-crop-outline"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("crop")}
              />
              <Ionicon
                icon="ios-refresh"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("rotate")}
              />
              <div className="editorButtonGroup">
                <Ionicon
                  icon="ios-checkmark"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("save")}
                />
                <Ionicon
                  icon="ios-close"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("close")}
                />
              </div>
            </div>
          </div>
        )}
        <span
          onClick={() => {
            this.props.step("back");
          }}
        >
          {NavigationArrow("prev")}
        </span>

        <span
          onClick={() => {
            this.props.step("forward");
          }}
        >
          {NavigationArrow("next")}
        </span>
        {this.state.saved && Saved}
      </div>
    );
  };
}
